import { computed, type MaybeRef } from 'vue';

import { useOrderQuery } from './query';

export function useOrder({ orderId }: { orderId: MaybeRef<string> }) {
  const orderQuery = useOrderQuery(orderId);

  const order = computed(() => orderQuery.data.value || null);
  const error = computed(() => orderQuery.error.value);

  const isLoading = computed(() => orderQuery.isLoading.value);
  const isError = computed(() => orderQuery.isError.value);

  const isNew = computed(() => order.value?.status === 'NEW');
  const isIssued = computed(
    () =>
      order.value?.status === 'PROCESS_OK' ||
      order.value?.status === 'PROCESS_MANUALLY',
  );
  const isInProgress = computed(
    () =>
      order.value?.status === 'PROCESS_PENDING' ||
      order.value?.status === 'PROCESS_IN_PROGRESS' ||
      order.value?.status === 'PROCESS_ERROR',
  );
  const isCanceled = computed(() => order.value?.status === 'CANCEL_OK');

  function refetch() {
    return orderQuery.refetch();
  }

  return {
    order,
    error,
    isLoading,
    isError,
    isNew,
    isIssued,
    isCanceled,
    isInProgress,
    refetch,
  };
}
